export const fmtGBP = (v) =>
  v == null || v === "" ? "—" : new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(Number(v));

export const fmtIDR = (v) =>
  v == null || v === "" ? "—" : new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(Number(v));

export const fmtDate = (iso, lang = "id") => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(lang === "id" ? "id-ID" : "en-GB", {
      day: "numeric", month: "long", year: "numeric",
    });
  } catch { return iso; }
};

export const fmtDateTime = (iso, lang = "id") => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(lang === "id" ? "id-ID" : "en-GB", {
      day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
};

export const gbpToIdr = (gbp, rate) => (gbp == null ? null : Number(gbp) * Number(rate || 0));
